import { UseQueryResult } from '@tanstack/react-query';

import { useKrakenQuery } from '@/components/GraphQLClient';
import { feedbackFormsSchema } from '@/hooks/CHISurvey/validations';

import GetCustomerFeedbackForms from './feedbackForms.graphql';

type FeedbackFormsQueryData = {
  customerFeedbackForms: {
    edges: {node: {id: string, name: "Positive" | "Negative" | "Neutral"}}[]
  }
}

export const useFeedbackFormsQuery = (accountNumber: string, first = 20): UseQueryResult<FeedbackFormsQueryData> => {
  return useKrakenQuery({
    queryKey: ['GetCustomerFeedbackForms'],
    variables: {
      accountNumber,
      first,
      feedbackSource: "FEEDBACK_SOURCE_CONSUMER_SITE"
    },
    query: GetCustomerFeedbackForms,
    validateFn(response) {
      return feedbackFormsSchema.validate(response);
    },
    
  });
};
